module.exports = __webpack_public_path__ + "static/media/dmn.3f9ded8a.svg";